/* __next_internal_client_entry_do_not_use__ AccordionListItem auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SafelySetInnerHTML } from "@faire/web--source/common/SafelySetInnerHTML";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Typography } from "@faire/web--source/slate/Typography";
import { Collapsable } from "@faire/web--source/ui/Collapsable/Collapsable";
import * as React from "react";
import styled from "styled-components";
import { getSpacing, GrowingSpacer } from "../spacing";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "../utils/highVisSlateComponent";
/** Single instance of a frequently asked question. Meant to be used as a part of Accordion and not individually  */ export var AccordionListItem = /*#__PURE__*/ React.forwardRef(function(param, ref) {
    var question = param.question, answer = param.answer, fromBuilder = param.fromBuilder, isCollapsed = param.isCollapsed, onClick = param.onClick, testId = param["data-test-id"];
    return /*#__PURE__*/ _jsxs(Container, {
        "data-test-id": testId,
        children: [
            /*#__PURE__*/ _jsxs(QuestionContainer, {
                type: "button",
                onClick: onClick,
                ref: ref,
                "data-test-id": testId && "".concat(testId, "__question"),
                children: [
                    typeof question === "string" ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "subheadingSansRegular",
                        children: question
                    }) : question,
                    /*#__PURE__*/ _jsx(GrowingSpacer, {
                        base: "3x"
                    }),
                    /*#__PURE__*/ _jsx(Chevron, {
                        direction: isCollapsed ? "down" : "up"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(AnswerContainer, {
                isCollapsed: isCollapsed,
                "data-test-id": testId && "".concat(testId, "__answer"),
                children: /*#__PURE__*/ _jsx(Answer, {
                    answer: answer,
                    fromBuilder: fromBuilder
                })
            })
        ]
    });
});
var Answer = function(param) {
    var answer = param.answer, fromBuilder = param.fromBuilder;
    // Builder will send HTML richText. This is to enable adding link in the answer section in Builder.
    if (fromBuilder) {
        return /*#__PURE__*/ _jsxs(Typography, {
            children: [
                /*#__PURE__*/ _jsx(SafelySetInnerHTML, {
                    html: answer
                }),
                " "
            ]
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: typeof answer === "string" ? /*#__PURE__*/ _jsx(Typography, {
            children: answer
        }) : answer
    });
};
var Container = styled.div.withConfig({
    componentId: "sc-1b70155d-0"
})([
    "box-sizing:border-box;width:100%;cursor:pointer;",
    ""
], highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
var AnswerContainer = styled(Collapsable).withConfig({
    componentId: "sc-1b70155d-1"
})([
    "padding-left:",
    ";padding-right:",
    ";padding-bottom:",
    ";cursor:initial;"
], getSpacing("3x"), getSpacing("3x"), function(param) {
    var isCollapsed = param.isCollapsed;
    return getSpacing(isCollapsed ? 0 : "2x");
});
var QuestionContainer = styled.button.withConfig({
    componentId: "sc-1b70155d-2"
})([
    "display:flex;flex-direction:row;width:100%;align-items:center;text-align:left;justify-content:space-between;padding:",
    ";"
], getSpacing("2x", "3x"));
